import React, { useState, useEffect } from "react"
import Application from "services/applications/Application.service"
import ReviewDirectorExport from "./Review/License/ReviewDirectorExport"

const appService = new Application(JSON.parse(localStorage.getItem("authUser")))

const Review = props => {
  const [viewComponent, setviewComponent] = useState()

  useEffect(() => {
    fetchApplicationDetails(props.location.search.split("=")[1])
  }, [])

  const fetchApplicationDetails = appId => {
    appService.getApplicationDetails(appId).then(response => {
      // console.log(response)
      if (response.status) {
        // if (response.data.service.id == 1) {
        //   setviewComponent(<ReviewDirectorExport appDetails={response.data} />)
        // } else if (response.data.service.id == 2) {
        //   setviewComponent(<ReviewDirectorExport appDetails={response.data} />)
        // }
        // else if (response.data.service.id == 3) {
        //   setviewComponent(<ReviewDirectorExport appDetails={response.data} />)
        // }
        //  else if (response.data.service.id == 4) {

        //   setviewComponent(<ReviewDirectorExport appDetails={response.data} />)
        // }
        setviewComponent(<ReviewDirectorExport appDetails={response.data} />)
      }
    })
  }

  return <>{viewComponent}</>
}

export default Review
